import Button from "@/components/core/Button/Button"
import styles from "@/components/DealershipEnquiry/DealershipEnquiryView/index.module.scss"
import { backToHomeAnalytics } from "@/components/DealershipEnquiry/analytics"
const Confirmation = props => {
  const { staticText } = props
  const onClick = () => {
    backToHomeAnalytics(window.location.href)
    window.location.href = "/"
  }

  return (
    <div className={styles.dealershipEnquiry}>
      <div className="dealership-enquiry__success-box">
        <h1 className="dealership-enquiry__success-message">
          {staticText?.messageHeaderSuccess}
        </h1>
        <div className="dealership-enquiry__success-description">
          {staticText?.dealershipConfirmationText}
        </div>
        <div className="container">
          <Button
            customClass={"kf-react-button"}
            className={"kf-react-button button large black flexible"}
            role="button"
            id="submit-contact-form-button"
            onClick={onClick}
            type="black"
            label={staticText?.dealershipConfiramtionCtaLabel}
          />
        </div>
      </div>
    </div>
  )
}

export default Confirmation
